/**
 * Names of all script functions.
 *
 * @module
 */

/** Script function type for `0x1::gas_schedule::set_gas_schedule`. */
export const set_gas_schedule = "0x1::gas_schedule::set_gas_schedule" as const;
